import React, { useEffect, useState } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL, submitFormData } from "../config/config";
import './Checkout_page.css';
import { Clock, Copy, CheckCircle, AlertCircle } from 'lucide-react';

const CheckoutPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [activeTab, setActiveTab] = useState({ name: '', address: '', id: '' });
  const [txHash, setTxHash] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
    const [copied, setCopied] = useState(false);
  
  
  // Image jaisa error show karne ke liye state
  const [validationError, setValidationError] = useState(false);

  const price = searchParams.get('price') || '0.00';
  const planName = searchParams.get('plan') || 'Document Service';
  const orderData = location.state?.orderData || {};
  const [generatedOrderId, setGeneratedOrderId] = useState('');

  const getPaymentMethods = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-payment-methods`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });
      const result = await response.json();
      if (result.success === 1) {
        setPaymentMethods(result.payment_methods);
        if (result.payment_methods.length > 0) {
          setActiveTab(result.payment_methods[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

const handleFinalSubmit = async () => {
    setErrorMessage('');
    const cleanTx = txHash.trim();
    
    // 1. Check if empty
    if (!cleanTx) {
      setValidationError(true);
      setErrorMessage("Please enter Transaction Hash (TXID)");
      return; 
    }

    // 2. Dynamic Format Validation based on Document [cite: 4]
    let isValid = false;
    let formatInstruction = "";
    const coinName = activeTab.name?.toUpperCase() || "";

    // Bitcoin, Litecoin, Ripple, Bitcoin Cash, Monero formats [cite: 4, 9, 12, 14, 25]
    if (["BTC", "BITCOIN", "LTC", "LITECOIN", "XRP", "RIPPLE", "BCH", "BITCOIN CASH", "XMR", "MONERO"].includes(coinName)) {
        isValid = /^[a-fA-F0-9]{64}$/.test(cleanTx);
        formatInstruction = "a 64-character alphanumeric string [cite: 4]";
    } 
    // Ethereum, BSC, Polkadot, Avalanche (0x + 64 hex characters) [cite: 7, 19, 23, 29]
    else if (["ETH", "ETHEREUM", "BSC", "BINANCE SMART CHAIN", "DOT", "POLKADOT", "AVAX", "AVALANCHE"].includes(coinName)) {
        isValid = /^0x[a-fA-F0-9]{64}$/.test(cleanTx);
        formatInstruction = "a 66-character string starting with '0x' [cite: 7]";
    }
    // Solana (Base58, usually 44 characters) 
    else if (["SOL", "SOLANA"].includes(coinName)) {
        isValid = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(cleanTx);
        formatInstruction = "a 44-character Base58 string ";
    }
    // Cardano (starts with 'a0' and 64 characters) 
    else if (["ADA", "CARDANO"].includes(coinName)) {
        isValid = /^a0[a-fA-F0-9]{62}$/.test(cleanTx);
        formatInstruction = "a 64-character string starting with 'a0' ";
    }
    // Tezos (starts with 'o') [cite: 27]
    else if (["XTZ", "TEZOS"].includes(coinName)) {
        isValid = /^o[a-km-zA-HJ-NP-Z1-9]{50,65}$/.test(cleanTx);
        formatInstruction = "a string starting with 'o' [cite: 27]";
    }
    // Fallback for others
    else {
        isValid = cleanTx.length >= 32;
        formatInstruction = "a valid transaction hash";
    }

    if (!isValid) {
        setValidationError(true);
        setErrorMessage(`Invalid format for ${activeTab.name}! Expected ${formatInstruction}.`);
        return;
    }

    setValidationError(false);
    setLoading(true);

    const finalPayload = {
      ...orderData,
      order_id: generatedOrderId,
      transaction_hash: cleanTx,
      payment_currency: activeTab.name,
      final_amount: price,
      status: 'pending',
      order_date: new Date().toISOString()
    };

    try {
      await submitFormData(finalPayload); 
      setTimeout(() => {
        setIsSubmitted(true);
        setLoading(false);
      }, 800);
    } catch (error) {
      console.log("Submission error:", error);
      setErrorMessage("Server error. Please try again.");
      setLoading(false);
    }
};

  useEffect(() => {
    getPaymentMethods();
  }, []);

  if (isSubmitted) {
    return (
      <div className="checkout-container">
        <div className="thank-you-card" style={{ textAlign: 'center', padding: '80px 20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
              <CheckCircle size={70} color="#16a34a" strokeWidth={1.5} />
          </div>
          <h1 style={{ fontSize: '2.5rem' }}>Thank you for your donation!</h1>
          {/* <p style={{ color: '#64748b', fontSize: '1.1rem', margin: '20px 0' }}>
            Your order has been received. TXID: <code>{txHash}</code>
          </p> */}
          <button className="pay-btn" onClick={() => navigate('/')}>Return to Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-container">
      <main className="checkout-main">
        <h1 className="checkout-title">Donate to us here
</h1>

        <div className="checkout-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          
          {/* Left Column: Information (Summary Hata Diya taake user direct ID dale) */}
          <div className="card" style={{ padding: '30px', height: '134px' }}>
            {/* <div className="card-content"> */}
             {/* <h3>Order Information</h3> */}
             <p >
                Thank you for your generosity. Support like yours is essential, it helps turn resources into real, tangible results.
             </p>
             {/* </div> */}
          </div>

          {/* Right Column: Payment Details */}
          <div className="card" style={{ padding: '30px' }}>
            <h3>Payment Method</h3>
            <div className="tabs" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              {paymentMethods.map((tab, index) => (
                <button
                  key={index}
                  className={`tab-btn ${activeTab.id === tab.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab(tab);
                    setValidationError(false);
                  }}
                  style={{ flex: 1, padding: '10px', cursor: 'pointer' }}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            <div className="payment-body">
              <div className="address-box">
                <label className="label-text">{activeTab.name} Deposit Address</label>
                <div className="input-group" style={{ display: 'flex', gap: '5px', marginTop: '8px' }}>
                  <div className="address-input" style={{ flex: 1, background: '#f1f5f9', padding: '10px', borderRadius: '5px', fontSize: '12px', wordBreak: 'break-all' }}>
                    {activeTab.address || 'Select a method'}
                  </div>
                  {/* <button className="copy-btn" onClick={() => {
                    navigator.clipboard.writeText(activeTab.address);
                  }} style={{ padding: '0 10px' }}><Copy size={16} /></button> */}
                  <button
                    className={`copy-btn ${copied ? "active" : ""}`}
                    onClick={() => {
                      navigator.clipboard.writeText(activeTab.address);
                      setCopied(true);
                  
                      // optional: 2 sec baad wapas normal ho jaye
                      setTimeout(() => setCopied(false), 2000);
                    }}
                  >
                    <Copy size={16} />
                  </button>
                </div>
              </div>

              <div style={{ marginTop: '25px' }}>
                <p style={{ fontSize: '13px', marginBottom: '15px', color: '#475569' }}>
                  After you make the payment enter the transaction hash here then click on (I Have Paid)
                </p>
                
                {/* LABEL AUR ERROR MESSAGE (Bilkul image jaisa) */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label className="label-text" style={{ fontWeight: '600' }}>Transaction Hash (TXID)</label>
                  {validationError && (
                    <span style={{ color: '#ef4444', fontSize: '12px', fontWeight: '600' }}>
                      Please enter Transaction Hash (TXID)
                    </span>
                  )}
                </div>

                <input
                  type="text"
                  className="address-input"
                  style={{ 
                    width: '100%', 
                    boxSizing: 'border-box', 
                    marginTop: '8px', 
                    padding: '12px',
                    borderRadius: '8px',
                    // Image jaisa Red Border
                    border: validationError ? '1px solid #ef4444' : '1px solid #cbd5e1',
                    outline: 'none',
                    backgroundColor: validationError ? '#fff5f5' : 'white'
                  }}
                  value={txHash}
                  onChange={(e) => {
                    setTxHash(e.target.value);
                    if(e.target.value.trim()) setValidationError(false);
                  }}
                  placeholder="Paste the transaction hash here"
                />
              </div>

              {/* Backend Error agar aaye to */}
              {errorMessage && (
                <div style={{ color: '#ef4444', fontSize: '13px', marginTop: '10px' }}>
                   {errorMessage}
                </div>
              )}

              <button
                className="pay-btn"
                style={{ 
                    marginTop: '30px', 
                    width: '100%', 
                    background: '#4f46e5', 
                    color: 'white', 
                    padding: '15px', 
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    fontWeight: 'bold'
                }}
                onClick={handleFinalSubmit}
                disabled={loading}
              >
                {loading ? "Processing..." : <><CheckCircle size={20} /> I Have Paid</>}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckoutPage;